import { render, staticRenderFns } from "./gjj.vue?vue&type=template&id=17a047ae&scoped=true"
import script from "./gjj.vue?vue&type=script&lang=js"
export * from "./gjj.vue?vue&type=script&lang=js"
import style0 from "./gjj.vue?vue&type=style&index=0&id=17a047ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a047ae",
  null
  
)

export default component.exports